(function() {
    'use strict';
    angular
        .module('app.filter')
        .filter('trustHtml', trustHtml);

    function trustHtml($sce) {
        return function(html) {
            return $sce.trustAsHtml(html);
        };
    }
})();

